export const QA_NAME_APPLICANT_PROFILE_OVERVIEW = 'applicantOverview'

export const APPLICANT_PROFILE_BLOCK_CONFLICT_NOTIFICATION_ID =
  'applicantBlockConflict'
